<template>
  <div class="facility-area-box">
    <span class="box-title">集合場所</span>
    <v-data-table
      :headers="headers"
      :items="items"
      class="elevation-0 meeting-table"
      locale="ja-jp"
      hide-default-footer
      hide-default-header
      item-key="key"
      no-data-text=""
      :items-per-page="500"
    >
      <template v-slot:[`item.eva_municip_code`]="{ item }">
        <v-select
          :items="municipalities"
          v-model="item.eva_municip_code"
          v-bind="$formControlProps(readOnly)"
          label="集合場所市町村"
          :placeholder="config.PLACEHOLDER_SELECT"
          @change="changeMunicipality(item)"
        ></v-select>
      </template>
      <template v-slot:[`item.fa_id`]="{ item }">
        <v-select
          :items="meetingForEdit[item.key]"
          v-model="item.fa_id"
          v-bind="$formControlProps(readOnly)"
          label="集合場所"
          :placeholder="config.PLACEHOLDER_SELECT"
          :error-messages="errorArea(item)"
          item-text="fa_name"
          item-value="fa_id"
        ></v-select>
      </template>
      <template v-slot:[`item.flagship_fa_flg`]="{ item }">
        <!-- 地図上の避難経路始点に設定(1: チェック、0: チェックなし) -->
        <v-radio-group
          v-model="flagshipSelection"
          :readonly="readOnly"
          dense
          hide-details
        >
          <v-radio
            :value="item.key"
            label="地図上の避難経路始点"
            @change="setFlagship(item)"
          ></v-radio>
        </v-radio-group>
      </template>
      <template v-slot:[`item.actions`]>
        <v-btn class="mx-2" color="primary" v-if="!readOnly" @click="addItem"
          >追加</v-btn
        >
      </template>
    </v-data-table>
  </div>
</template>
<script>
import cloneDeep from "lodash/cloneDeep";
import maxBy from "lodash/maxBy";
import config from "@/js/const";

export default {
  name: "MeetingInfo",
  data: () => ({
    config: config,
    items: [],
    meetingForEdit: [],
    flagshipSelection: null
  }),
  props: {
    //親から受け取るデータ
    meetingInfo: {
      type: Array,
      default: () => []
    },
    editedMeetingInfo: {
      type: Array,
      default: () => []
    },
    municipalities: {
      type: Array,
      default: () => []
    },
    facilities: {
      type: Array,
      default: () => []
    },
    readOnly: {
      type: Boolean
    },
    autonomyCd: {
      type: String
    }
  },
  watch: {
    items: {
      handler: function(newItems) {
        this.$emit("update:editedMeetingInfo", newItems);
      },
      deep: true
    },
    autonomyCd: "initialize"
  },
  mounted() {
    this.initialize();
  },
  computed: {
    headers() {
      return [
        {
          text: "集合場所市町村",
          value: "eva_municip_code",
          sortable: false
        },
        {
          text: "集合場所",
          value: "fa_id",
          sortable: false
        },
        {
          text: "代表集合場所",
          value: "flagship_fa_flg",
          sortable: false
        },
        {
          text: "操作",
          value: "actions",
          sortable: false
        }
      ];
    }
  },
  methods: {
    initialize() {
      if (this.editedMeetingInfo.length == 0) {
        this.items = cloneDeep(this.meetingInfo);
      } else {
        this.items = cloneDeep(this.editedMeetingInfo);
      }

      this.items.forEach(item => {
        this.changeMunicipality(item);
        // 代表集合場所の初期値設定
        if (item.flagship_fa_flg === "1") {
          this.flagshipSelection = item.key;
        }
      });
    },
    addItem() {
      const maxItem = maxBy(this.items, "key");
      this.items.push({
        key: maxItem.key + 1,
        eva_municip_code: "",
        fa_id: "",
        flagship_fa_flg: "0"
      });
    },
    // 市町村が変更されたとき
    async changeMunicipality(item) {
      //市町村が空の時は集合場所の選択をクリア
      if (item.eva_municip_code === "" || item.eva_municip_code === undefined) {
        item.fa_id = "";
      }
      //集合場所リストボックス設定
      if (this.facilities.length > 0) {
        //選択市町村・集合場所のみに絞込み
        this.meetingForEdit[item.key] = this.facilities.filter(
          facility => facility.ju_municip_code === item.eva_municip_code
        );
      }
    },
    errorArea(item, items = this.items) {
      // 集合場所の重複チェック
      if (!item.fa_id) {
        return "";
      }
      const hasItem = items.some(data => {
        return item.key !== data.key && item.fa_id === data.fa_id;
      });
      if (hasItem) {
        return "重複しています。";
      }
      return "";
    },
    setFlagship(selectedItem) {
      // 全てのアイテムの代表フラグをリセット
      this.items.forEach(item => {
        item.flagship_fa_flg = "0";
      });
      // 選択されたアイテムのみ代表フラグを設定
      selectedItem.flagship_fa_flg = "1";
      this.flagshipSelection = selectedItem.key;
    },
    prepareMeetingInfoForSave() {
      // ラジオボタンが選択されていない場合、全てのflagship_fa_flgを0に設定
      if (!this.flagshipSelection) {
        this.items.forEach(item => {
          item.flagship_fa_flg = "0";
        });
      }
    },
    validate() {
      let validate = true;

      // 重複チェック
      this.editedMeetingInfo.forEach(item => {
        if (this.errorArea(item, this.editedMeetingInfo) !== "") {
          validate = false;
          return false;
        }
      });

      // 2行以上でfa_idが空の時にflagship_fa_flgにチェックが付いている場合のエラーチェック
      if (this.editedMeetingInfo.length > 1) {
        const invalidFlagshipItems = this.items.filter(
          item => !item.fa_id && item.flagship_fa_flg === "1"
        );
        if (invalidFlagshipItems.length > 0) {
          validate = false;
        }
      }
      return validate === true;
    },

    // 集合場所のバリデーションエラーメッセージを取得
    getFlagshipValidationError() {
      // 2行以上でfa_idが空の時にflagship_fa_flgにチェックが付いている場合のエラーチェック
      if (this.editedMeetingInfo.length > 1) {
        const invalidFlagshipItems = this.items.filter(
          item => !item.fa_id && item.flagship_fa_flg === "1"
        );
        if (invalidFlagshipItems.length > 0) {
          return "集合場所が未選択の行で避難経路始点が選択されています。";
        }
      }
      return "";
    }
  }
};
</script>
